'use client';

import { forwardRef } from 'react';

type VideoElementProps = {
	src?: string | null;
	srcObject?: MediaStream | null;
	controls?: boolean;
	muted?: boolean;
	autoPlay?: boolean;
	mirrored?: boolean;
	playsInline?: boolean;
	visible?: boolean;
	isPortrait?: boolean;
};

export const VideoElement = forwardRef<HTMLVideoElement, VideoElementProps>(
	(
		{
			src,
			controls = false,
			muted = true,
			autoPlay = false,
			mirrored = false,
			playsInline = true,
			visible = true,
			isPortrait = false,
		},
		ref
	) => {
		// Use object-contain for portrait to show full frame (letterboxed), object-cover for landscape
		const objectFit = isPortrait ? 'object-contain' : 'object-cover';

		return (
			<video
				ref={ref}
				src={src || undefined}
				controls={controls}
				muted={muted}
				autoPlay={autoPlay}
				playsInline={playsInline}
				className={`h-64 w-full md:h-80 lg:h-96 ${objectFit}`}
				style={{
					display: visible ? 'block' : 'none',
					transform: mirrored ? 'scaleX(-1)' : 'none',
				}}
			>
				<track kind="captions" />
			</video>
		);
	}
);

VideoElement.displayName = 'VideoElement';
